export const META_PIXEL_ID = '1604866424331293'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (document.getElementById(SCRIPT_ID)) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    const instance = window.fbq
    if (!instance) return
    if (instance.callMethod) {
      instance.callMethod.apply(instance, args)
    } else {
      instance.queue?.push(args)
    }
  } as Window['fbq']

  if (fbq) {
    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
  }

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const pixelImage = document.createElement('img')
  pixelImage.height = 1
  pixelImage.width = 1
  pixelImage.style.display = 'none'
  pixelImage.alt = ''
  pixelImage.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImage)
  document.head.appendChild(noscript)

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', eventName, params)
}
